import {
  SET_USER
} from './mutation-types'

export default {
  [SET_USER]: (state, { user }) => {
    state.user = user
  }
}
